module.exports = "/_next/static/images/PipelineTransmissionSystemsServices-43aa46818ac16f0d5709f38560b0cb99.webp";